import { useState, useEffect, Fragment } from 'react'
import { FiList, FiRefreshCw, FiThumbsUp, FiThumbsDown, FiSearch } from 'react-icons/fi'
import api from '../utils/api'

// Akilli Arama kayitlari (super_admin): kim ne sordu, anlasildi mi, sonuc bos mu, begenildi mi.
// "Sorunlular" = anlasilamayan + bos + hata + "aradigim bu degil" -> aramayi gelistirmek icin is listesi.
const DURUM = {
  tamam: { ad: 'Cevaplandı', renk: 'bg-green-50 text-green-700 dark:bg-green-900 dark:text-green-200' },
  anlasilamadi: { ad: 'Anlaşılamadı', renk: 'bg-orange-50 text-orange-700 dark:bg-orange-900 dark:text-orange-200' },
  kapsam_disi: { ad: 'Veride yok', renk: 'bg-purple-50 text-purple-700 dark:bg-purple-900 dark:text-purple-200' },
  bos: { ad: 'Sonuç boş', renk: 'bg-yellow-50 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-200' },
  hata: { ad: 'Hata', renk: 'bg-red-50 text-red-700 dark:bg-red-900 dark:text-red-200' },
}
const fmtZaman = (s) => {
  const m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}:\d{2})/)
  return m ? `${m[3]}.${m[2]}.${m[1]} ${m[4]}` : s
}

function Kart({ baslik, deger, renk = 'text-gray-800 dark:text-gray-100', onClick, aktif }) {
  return (
    <button onClick={onClick}
      className={`text-left bg-white dark:bg-gray-800 rounded-xl border p-3 ${aktif ? 'border-blue-500 ring-1 ring-blue-500' : 'border-gray-200 dark:border-gray-700'}`}>
      <div className="text-xs text-gray-500">{baslik}</div>
      <div className={`text-xl font-bold ${renk}`}>{deger ?? 0}</div>
    </button>
  )
}

function IncelemeNotu({ satir }) {
  const [metin, setMetin] = useState(satir.inceleme || '')
  const [kayit, setKayit] = useState(false)
  const kaydet = async () => {
    if ((satir.inceleme || '') === metin) return
    await api.put(`/akilli-arama/log/${satir.id}/inceleme`, { metin })
    satir.inceleme = metin
    setKayit(true); setTimeout(() => setKayit(false), 1500)
  }
  return (
    <input value={metin} onChange={(e) => setMetin(e.target.value)} onBlur={kaydet}
      onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur() }}
      placeholder="Not (ör. eklendi / veri yok)"
      className={`w-full min-w-[140px] px-2 py-1 text-xs border rounded bg-white dark:bg-gray-900 dark:text-gray-100 ${kayit ? 'border-green-500' : 'border-gray-200 dark:border-gray-600'}`} />
  )
}

export default function AramaKayitlari() {
  const [veri, setVeri] = useState(null)
  const [yuk, setYuk] = useState(false)
  const [gun, setGun] = useState(30)
  const [filtre, setFiltre] = useState('sorunlu') // sorunlu | tumu | durum adi
  const [ara, setAra] = useState('')
  const [acik, setAcik] = useState(null)

  const yukle = async () => {
    setYuk(true)
    const p = { gun }
    if (filtre === 'sorunlu') p.sorunlu = true
    else if (filtre !== 'tumu') p.durum = filtre
    if (ara.trim()) p.ara = ara.trim()
    try { setVeri((await api.get('/akilli-arama/log', { params: p })).data) } catch (e) { console.error(e) }
    setYuk(false)
  }
  useEffect(() => { yukle() }, [gun, filtre]) // eslint-disable-line react-hooks/exhaustive-deps

  const o = veri?.ozet || {}
  return (
    <div className="p-3 md:p-5 max-w-7xl mx-auto">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <div className="flex-1 min-w-[200px]">
          <h1 className="text-lg md:text-xl font-bold flex items-center gap-2 text-gray-800 dark:text-gray-100"><FiList /> Arama Kayıtları</h1>
          <p className="text-[11px] text-gray-500">Akıllı Arama'da sorulan her soru. Sorunlu olanlar: anlaşılamayan, boş dönen, hata veren ve kullanıcının "aradığım bu değil" dedikleri.</p>
        </div>
        <select value={gun} onChange={(e) => setGun(Number(e.target.value))}
          className="px-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 dark:text-gray-100">
          <option value={1}>Son 24 saat</option><option value={7}>Son 7 gün</option><option value={30}>Son 30 gün</option>
          <option value={90}>Son 90 gün</option><option value={3650}>Tümü</option>
        </select>
        <form onSubmit={(e) => { e.preventDefault(); yukle() }} className="relative">
          <FiSearch className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
          <input value={ara} onChange={(e) => setAra(e.target.value)} placeholder="Soru / kullanıcı ara"
            className="pl-8 pr-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 dark:text-gray-100" />
        </form>
        <button onClick={yukle} className="p-2 rounded-lg text-gray-500 hover:text-blue-600 hover:bg-blue-50 dark:hover:bg-gray-800">
          <FiRefreshCw size={16} className={yuk ? 'animate-spin' : ''} />
        </button>
      </div>

      <div className="grid gap-2 mb-4" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))' }}>
        <Kart baslik="Toplam soru" deger={o.toplam} onClick={() => setFiltre('tumu')} aktif={filtre === 'tumu'} />
        <Kart baslik="Sorunlu" deger={(o.anlasilamadi || 0) + (o.bos || 0) + (o.hata || 0) + (o.kapsam_disi || 0)} renk="text-orange-600"
          onClick={() => setFiltre('sorunlu')} aktif={filtre === 'sorunlu'} />
        <Kart baslik="Cevaplandı" deger={o.tamam} renk="text-green-600" onClick={() => setFiltre('tamam')} aktif={filtre === 'tamam'} />
        <Kart baslik="Anlaşılamadı" deger={o.anlasilamadi} renk="text-orange-600" onClick={() => setFiltre('anlasilamadi')} aktif={filtre === 'anlasilamadi'} />
        <Kart baslik="Sonuç boş" deger={o.bos} renk="text-yellow-600" onClick={() => setFiltre('bos')} aktif={filtre === 'bos'} />
        <Kart baslik="Veride yok" deger={o.kapsam_disi} renk="text-purple-600" onClick={() => setFiltre('kapsam_disi')} aktif={filtre === 'kapsam_disi'} />
        <Kart baslik="Hata" deger={o.hata} renk="text-red-600" onClick={() => setFiltre('hata')} aktif={filtre === 'hata'} />
        <Kart baslik="👍 / 👎" deger={`${o.begendi || 0} / ${o.begenmedi || 0}`} />
        <Kart baslik="Kullanıcı · ort. süre" deger={`${o.kullanici || 0} · ${((o.ort_ms || 0) / 1000).toFixed(1)}s`} />
      </div>
      {filtre === 'sorunlu' && <p className="text-[11px] text-gray-500 -mt-2 mb-3">Kartlardaki sayılar seçili filtreye göre; "Sorunlu" filtresinde 👎 verilen ama cevaplanan sorular da listede.</p>}

      {veri?.sik?.length > 0 && (
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-3 mb-4">
          <div className="text-xs font-semibold text-gray-500 mb-2">En sık sorulanlar</div>
          <div className="flex flex-wrap gap-1.5">
            {veri.sik.map(s => (
              <span key={s.soru} className={`px-2 py-1 text-xs rounded-full ${s.sorunlu ? 'bg-orange-50 text-orange-700 dark:bg-orange-900 dark:text-orange-200' : 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200'}`}>
                {s.soru} <b>×{s.adet}</b>
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 dark:bg-gray-900 text-gray-600 dark:text-gray-300 text-xs">
            <tr>
              <th className="px-3 py-2 text-left">Zaman</th><th className="px-3 py-2 text-left">Firma / Kullanıcı</th>
              <th className="px-3 py-2 text-left">Soru</th><th className="px-3 py-2 text-left">Durum</th>
              <th className="px-3 py-2 text-left">Anladığı</th><th className="px-3 py-2 text-right">Satır</th>
              <th className="px-3 py-2 text-left">Geri bildirim</th><th className="px-3 py-2 text-left">İnceleme</th>
            </tr>
          </thead>
          <tbody>
            {veri?.satirlar?.map(r => {
              const a = r.anlasilan || {}
              const d = DURUM[r.durum] || {}
              return (
                <Fragment key={r.id}>
                  <tr onClick={() => setAcik(acik === r.id ? null : r.id)}
                    className="border-t border-gray-100 dark:border-gray-700 hover:bg-blue-50 dark:hover:bg-gray-700 cursor-pointer align-top">
                    <td className="px-3 py-2 whitespace-nowrap text-gray-500 text-xs">{fmtZaman(r.zaman)}</td>
                    <td className="px-3 py-2 text-xs"><div className="text-gray-800 dark:text-gray-200">{r.firma}</div><div className="text-gray-400">{r.kullanici}</div></td>
                    <td className="px-3 py-2 font-medium text-gray-800 dark:text-gray-100">{r.soru}</td>
                    <td className="px-3 py-2"><span className={`px-2 py-0.5 rounded text-xs whitespace-nowrap ${d.renk}`}>{d.ad || r.durum}</span></td>
                    <td className="px-3 py-2 text-xs text-gray-600 dark:text-gray-300">
                      {[a.niyet, (a.isletme || []).join(', '), a.donem, a.cari && `Cari: ${a.cari.slice(0, 3).join(', ')}`].filter(Boolean).join(' · ')}
                    </td>
                    <td className="px-3 py-2 text-right tabular-nums text-xs">{r.satir_sayisi}</td>
                    <td className="px-3 py-2 text-xs">
                      {r.puan === 1 && <FiThumbsUp className="text-green-600 inline" />}
                      {r.puan === -1 && <FiThumbsDown className="text-orange-600 inline" />}
                      {r.yorum && <div className="text-gray-700 dark:text-gray-200 mt-0.5">“{r.yorum}”</div>}
                    </td>
                    <td className="px-3 py-2" onClick={(e) => e.stopPropagation()}><IncelemeNotu satir={r} /></td>
                  </tr>
                  {acik === r.id && (
                    <tr className="bg-gray-50 dark:bg-gray-900">
                      <td colSpan={8} className="px-3 py-2 text-xs text-gray-600 dark:text-gray-300">
                        <div><b>Cevap:</b> {r.ozet || '—'}</div>
                        <div className="mt-1 text-gray-400">{r.tablo_sayisi} tablo · {r.sure_ms} ms{r.hata && <span className="text-red-600"> · Hata: {r.hata}</span>}</div>
                      </td>
                    </tr>
                  )}
                </Fragment>
              )
            })}
            {veri && !veri.satirlar?.length && (
              <tr><td colSpan={8} className="px-3 py-8 text-center text-gray-400">Bu filtrede kayıt yok.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
